const AUTH_TOKEN_KEY = 'auth_token';
const SUBSCRIPTION_ACTIVE_KEY = 'subscription_active';
const AUTH_USER_KEY = 'auth_user';

const dispatchAuthChange = () => window.dispatchEvent(new Event('auth-change'));
const dispatchSubscriptionChange = () => window.dispatchEvent(new Event('subscription-change'));

export const authStorage = {
  getToken() {
    return localStorage.getItem(AUTH_TOKEN_KEY);
  },
  getUser<T = unknown>() {
    const rawUser = localStorage.getItem(AUTH_USER_KEY);

    if (!rawUser) return null;

    try {
      return JSON.parse(rawUser) as T;
    } catch {
      localStorage.removeItem(AUTH_USER_KEY);
      return null;
    }
  },
  hasToken() {
    return Boolean(localStorage.getItem(AUTH_TOKEN_KEY));
  },
  hasActiveSubscription() {
    return localStorage.getItem(SUBSCRIPTION_ACTIVE_KEY) === 'true';
  },
  setToken(token: string) {
    localStorage.setItem(AUTH_TOKEN_KEY, token);
    localStorage.setItem(SUBSCRIPTION_ACTIVE_KEY, 'false');
    dispatchAuthChange();
    dispatchSubscriptionChange();
  },
  setUser(user: unknown) {
    localStorage.setItem(AUTH_USER_KEY, JSON.stringify(user));
    dispatchAuthChange();
  },
  setSubscriptionActive(isActive: boolean) {
    localStorage.setItem(SUBSCRIPTION_ACTIVE_KEY, String(isActive));
    dispatchSubscriptionChange();
  },
  clearToken() {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    localStorage.removeItem(SUBSCRIPTION_ACTIVE_KEY);
    localStorage.removeItem(AUTH_USER_KEY);
    dispatchAuthChange();
    dispatchSubscriptionChange();
  },
};
